import { render } from "./ReportShare.vue?vue&type=template&id=e1dcdb3a&scoped=true"
import script from "./ReportShare.vue?vue&type=script&lang=js"
export * from "./ReportShare.vue?vue&type=script&lang=js"

import "./ReportShare.vue?vue&type=style&index=0&id=e1dcdb3a&lang=scss&scoped=true"

import exportComponent from "/var/www/testback/Frontend/sdd/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e1dcdb3a"]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDialog});
